export default __webpack_public_path__ + "static/media/title-img.0be85c3d.png";